export default "__VITE_ASSET__Bp3zf5uv__"